import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

/** The one control that folds a floating panel or legend to its title bar and back.
 *  A press on it never starts the panel's drag. */
export default function CollapseToggle({ collapsed, onToggle, name }) {
  return (
    <button
      type="button"
      className="collapse-toggle"
      aria-expanded={!collapsed}
      aria-label={`${collapsed ? 'Expand' : 'Collapse'} ${name}`}
      title={collapsed ? 'Expand' : 'Collapse'}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
    >
      {collapsed ? <FaChevronDown size={10} /> : <FaChevronUp size={10} />}
    </button>
  );
}
